import React from "react";
import { getCookie } from "../helperFunctions/cookie";
import { updateList } from "../api-interactions/lists";
import { getFamily, updateFamily } from "../api-interactions/family";
import "./list-item.css";

export const ListItems = (props) => {
  const jwt = getCookie();
  const user = JSON.parse(localStorage.getItem("user"));

  const changeHandler = async (e) => {
    const itemId = e.target.id;
    const itemProperties = itemId.split(";");
    itemProperties.push(e.target.checked);

    const earnedPoints = itemProperties[2];

    const newItem = {
      key: itemProperties[0],
      name: itemProperties[1],
      pointComplete: itemProperties[2],
      addedBy: itemProperties[3],
      finished: itemProperties[4],
    };

    props.list.items = props.list.items.filter(function (obj) {
      return obj.key !== newItem.key;
    });

    props.list.items.push(newItem);
    let members = await getFamily(user);
    const specificMember = members.filter((obj) => {
      if (obj.userId === user._id) {
        const index = members.indexOf(obj);
        members.splice(index, 1);
      }
      return obj.userId === user._id;
    });

    if (newItem.finished) {
      specificMember[0].amountOfPoints =
        parseInt(specificMember[0].amountOfPoints) + parseInt(earnedPoints);
    } else {
      specificMember[0].amountOfPoints =
        parseInt(specificMember[0].amountOfPoints) - parseInt(earnedPoints);
    }

    members = [...members, specificMember[0]];
    const newMembers = members;

    updateFamily(jwt, user, { members: newMembers });
    updateList(jwt, props.list._id, props.list);
  };

  let classListContainer;
  let classListBlur;

  if (props.fullHeight) {
    classListContainer = "list-items-container full-height";
    classListBlur = "box-blur full-height-blur";
  } else {
    classListContainer = "list-items-container";
    classListBlur = "box-blur";
  }

  return (
    <React.Fragment>
      <div className={classListContainer}>
        {props.items.map((value) => {
          if (value.finished) return;
          return (
            <div key={value.key}>
              <input
                defaultChecked={value.finished}
                onChange={changeHandler}
                id={
                  value.key +
                  ";" +
                  value.name +
                  ";" +
                  value.pointComplete +
                  ";" +
                  value.addedBy
                }
                name="taskname"
                type="checkbox"
              />
              <label
                className="list-item-text"
                htmlFor={
                  value.key +
                  ";" +
                  value.name +
                  ";" +
                  value.pointComplete +
                  ";" +
                  value.addedBy
                }
              >
                {value.name}
              </label>
              {value.link && (
                <a
                  className="link-to-list"
                  href={"/dashboard/lists/" + value.link}
                >
                  list
                </a>
              )}
            </div>
          );
        })}
        <div className={classListBlur}></div>
      </div>
    </React.Fragment>
  );
};
